import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import cn from 'classnames'
import Loader from '../common/Loader'
import {showModal, CONFIRM, TRASHED_QUESTION_MODAL} from '../../modules/modals'
import {trashedQuestionsSortedSelector, trashedCursorSelector, setTrashedCursor, removeTrash, removeAllTrash, currentTrashedPreviewItemSelector, checkAndUploadTrashed, trashedLoadStateSelector, recoverTrash, trashedStatisticSelector} from '../../modules/questions'
import minusButtonIcon from '../../_static/images/minusButton.svg'
import minusButtonActiveIcon from '../../_static/images/minusButtonActive.svg'
import trashIconActive from '../../_static/images/garbageIcon-white.svg'
import trashIcon from '../../_static/images/garbageIcon-gray.svg'
import {QBM_NAV_TRASHED} from '../../modules/app'
import { isTeacherOrganisationSelector } from '../../modules/profile'
import {Link} from 'react-router-dom'
import { routesUrls } from '../../settings/routes'


class Trashed extends Component {
    render() {
        const {openItemId, onClick, trashedStatistic, isTeacherOrganisation, permission} = this.props
        const isOpen = openItemId === QBM_NAV_TRASHED
        const {formatMessage} = this.context

        if(isTeacherOrganisation && !permission.allow_empty_trash){
            return null
        }

        return (
            <div className="qbm-accordion-component">
                <Link to={routesUrls.trashed} className="qbm-accordion-title"  onClick={this.onClick}>{formatMessage("Trashed questions")} {
                    typeof trashedStatistic !== 'undefined' ?
                        `(${trashedStatistic.count})` :
                        ''
                }
                    {/* <div className={cn({"qbm-accordion-arrow":1, open : isOpen})}></div> */}
                </Link>
            </div>
        )
    }

    onClick = () => {

    }

    componentDidMount() {
        const {checkAndUploadTrashed} = this.props
        checkAndUploadTrashed()
    }

    getBody = () => {
        const {trashed, trashedCursor, loading} = this.props
        const {Item} = this
        Item.displayName = "Item"
        if (loading) return <Loader className="accordion-sidebar-preloader" />

        return (
            <React.Fragment>
                <div className="qbm-accordion-content">
                    {
                        !trashed.length &&
                        <span className="qbm-accordion-content__item-text qbm-accordion-content__item-text--no-x-borders">{this.context.formatMessage("There is no questions in the trash")}</span>
                    }
                    {
                        trashed.map(({id, body : text}) => (
                            <Item
                                key = {id}
                                handleClick = {this.handleItemClick(id)}
                                text = {text}
                                isSelected = {trashedCursor === id}
                                handleDoubleClick = {this.handleDoubleClick(id)}
                            />
                        ))
                    }
                </div>
                <div className="qbm-accordion-action-panel">
                    <div
                        onClick = {this.handleActionButtonClick('zoom')}
                        className="qbm-accordion-action-panel__action-button"
                    >
                        <span
                            className={cn("qbm-accordion-action-icon pointer", {"qbm-accordion-action-icon--active": !!trashedCursor})}
                            title = {this.context.formatMessage("Details")}
                        >
                            <span className="glyphicon glyphicon-search"></span>
                        </span>
                    </div>
                    <div
                        onClick = {this.handleActionButtonClick('recover')}
                        className="qbm-accordion-action-panel__action-button"
                    >
                        <span
                            className = {cn("qbm-accordion-action-icon pointer", {"qbm-accordion-action-icon--active": !!trashedCursor})}
                            title = {this.context.formatMessage("Recover")}
                        >
                            <span className="glyphicon glyphicon-repeat"></span>
                        </span>
                    </div>
                    <div
                        onClick = {this.handleActionButtonClick('delete')}
                        className="qbm-accordion-action-panel__action-button"
                    >
                        <img
                            src={!!trashedCursor ? minusButtonActiveIcon : minusButtonIcon}
                            alt = {this.context.formatMessage("Remove")}
                            title = {this.context.formatMessage("Remove")}
                        />
                    </div>

                    <div
                        onClick = {this.handleActionButtonClick('delete-all')}
                        className="qbm-accordion-action-panel__action-button"
                    >
                        <img
                            src={trashed.length ? trashIconActive : trashIcon}
                            alt = {this.context.formatMessage("Empty Trash")}
                            title = {this.context.formatMessage("Empty Trash")}
                        />
                    </div>
                </div>
            </React.Fragment>
        )
    }

    Item = ({text, isSelected, handleClick, handleDoubleClick}) => (
        <div
            onClick = {handleClick}
            className = {cn("qbm-accordion-html-item pointer", {"qbm-accordion-html-item--active" : isSelected})}
            onDoubleClick = {handleDoubleClick}
            dangerouslySetInnerHTML = {{
                __html : text,
            }}
        />
    )

    handleItemClick = id => (event) => {
        event.preventDefault() // if there is a anchor in trashed question body (html)
        const {setTrashedCursor} = this.props
        setTrashedCursor({trashedQuestionId : id})
    }

    handleDoubleClick = id => () => {
        const {setTrashedCursor} = this.props
        setTrashedCursor({trashedQuestionId : id})
        this.handleZoom()
    }

    handleActionButtonClick = (action) => () => {
        const {trashedCursor} = this.props

        if (action !== "delete-all" && !trashedCursor && ["zoom", "recover", "delete"].includes(action)) return

        if (action === 'zoom') {
            this.handleZoom()
        } else if (action === 'recover') {
            this.handleRecover()
        } else if (action === 'delete') {
            this.handleRemove()
        } else if (action === "delete-all") {
            this.handleRemoveAll()
        }
    }

    handleRemoveAll = () => {
        const {trashed, showModal, removeAllTrash, currentTrashed : {form : {errors : {removeErr : errors = []} = {}} = {}} = {}} = this.props
        if (!trashed.length) return
        const {formatMessage} = this.context
        showModal({
            modalType : CONFIRM,
            modalProps : {
                title : formatMessage("Empty Trash"),
                confirmText : formatMessage(`Are you sure you want permanently erase the items in the trash? You can’t undo this action.`),
                okButtonTxt : formatMessage("Yes"),
                cancelButtonTxt : formatMessage("Cancel"),
                okCb : () => removeAllTrash(),
                errors,
            }
        })
    }

    handleRemove = () => {
        const {showModal, trashedCursor, removeTrash, currentTrashed : {form : {errors : {removeErr : errors = []} = {}} = {}} = {}} = this.props
        const {formatMessage} = this.context
        showModal({
            modalType : CONFIRM,
            modalProps : {
                title : formatMessage("Deleting trashed question"),
                confirmText : formatMessage(`Do you really want completely delete the question with id`) + `: ${trashedCursor}?`,
                okButtonTxt : formatMessage("Yes"),
                cancelButtonTxt : formatMessage("No"),
                okCb : () => removeTrash({trashedQuestionId : trashedCursor}),
                errors,
            }
        })
    }

    handleZoom = () => {
        const {showModal} = this.props
        showModal({
            modalType : TRASHED_QUESTION_MODAL,
            modalProps : {
                recoverCB : () => {
                    this.handleRecover()
                },
                removeCB : () => {
                    this.handleRemove()
                },
            }
        })
    }

    handleRecover = () => {
        const {trashedCursor, recoverTrash} = this.props
        recoverTrash({trashedQuestionId : trashedCursor})
    }

    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => {
        const {loading} = trashedLoadStateSelector(state)
        const trashed = trashedQuestionsSortedSelector(state)
        const trashedCursor = trashedCursorSelector(state)
        const currentTrashed = currentTrashedPreviewItemSelector(state)
        return {
            trashed,
            trashedCursor,
            currentTrashed,
            loading,
            trashedStatistic : trashedStatisticSelector(state),
            permission: state.profile.permission || {},
            isTeacherOrganisation: isTeacherOrganisationSelector(state),
        }
    },
    {showModal, setTrashedCursor, removeTrash, removeAllTrash, checkAndUploadTrashed, recoverTrash}
)(Trashed)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/Trashed.js